import { actionTypes } from '../actions/leads';
import { leads as defaultState } from './default.json';

const handlers = {
  [actionTypes.LEADS_POST_ERROR]: (state, action) => ({
    ...state,
    leadsErrorStatus: action.error.message,
    requestInProgress: false,
  }),
  [actionTypes.LEADS_POST_IN_PROGRESS]: state => ({
    ...state,
    requestInProgress: true,
  }),
  [actionTypes.LEADS_POST_SUCCESS]: state => ({
    ...state,
    leadsSuccessStatus: true,
    requestInProgress: false,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
